import { Currency } from './market.domain';

export enum RateSource {
  IBM = 'IBM',
  MPOWER = 'MPOWER',
  WIPP = 'WIPP',
  CROESUS = 'CROESUS'
}

export interface ExchangeRate {
  source: RateSource;
  from: Currency;
  to: Currency;
  rate: number;
}

export type ExchangeRates = Partial<Record<RateSource, Array<ExchangeRate>>>;

